import { gql, useMutation } from "@apollo/client";
import { useToast } from "@teamrota/rota-design";

const BULK_MUTATE_ACCOUNT_CONTACTS = gql`
  mutation BulkMutateAccountContacts(
    $accountId: ID!
    $contacts: [ContactInputType!]!
  ) {
    bulkMutateAccountContacts(accountId: $accountId, contacts: $contacts) {
      id
      name
      email
      priority
    }
  }
`;

function useBulkMutateAccountContacts() {
  const [bulkMutateAccountContacts, { data, loading }] = useMutation(
    BULK_MUTATE_ACCOUNT_CONTACTS
  );

  const { showToast } = useToast();

  const bulkMutateAccountContactsMutation = async variables => {
    try {
      const response = await bulkMutateAccountContacts({ variables });

      showToast("Updated", { severity: "success" });

      return response.data.bulkMutateAccountContacts;
    } catch (e) {
      showToast(e.message, { severity: "error" });
    }
  };

  return {
    bulkMutateAccountContacts: bulkMutateAccountContactsMutation,
    data,
    loading
  };
}

export default useBulkMutateAccountContacts;
